import { createContext, Dispatch, SetStateAction } from 'react';
import User from '../interfaces/User';

interface AuthContextProps {
  currentUser: User | null;
  setCurrentUser: Dispatch<SetStateAction<User | null>>;
  login: () => void;
  logout: () => void;
  isNew: boolean;
  isLoading: boolean;
  /** Hydrates currentUser from a stored partner session. Resolves true on success. */
  loadPartnerSessionUser: () => Promise<boolean>;
}

const AuthContext = createContext<AuthContextProps>({
  currentUser: null,
  setCurrentUser: () => {},
  login: () => {},
  logout: () => {},
  isNew: true,
  isLoading: true,
  loadPartnerSessionUser: async () => false,
});

export default AuthContext;
